import React from "react";
import { useTranslation } from "react-i18next";
import { RetryProps } from "../models/Types";

export default function Retry(props: RetryProps) {
  const { t } = useTranslation();

  return (
    <div className={"retryContainer"}>
      <img className={"rotate"} src={`static/retry.svg`} width={110} alt="" />

      <div className={"sorryMessage"}>
        <h1>{t("VerificationUnsuccessful.text")}</h1>
        {props.expired && <p>{t("ChallengeExpired.text")}</p>}
      </div>

      <button
        type="button"
        className="btn rounded-full btn-small btn-solid-purple btn-full-width"
        onClick={props.retryCallback}
      >
        <div>{t("Retry.text")}</div>
      </button>

      {props.allowedChallenges.length > 1 && (
        <button
          className={
            "btn btn-small rounded-full btn-outline-grey btn-full-width"
          }
          onClick={props.tryAnotherChallengeCallback}
        >
          {t("ResetChallenge.text")}
        </button>
      )}

      <p className={"problem-area"}>
        {t("HaveAProblem.text")}{" "}
        <a
          href="https://proton.me/support/contact?topic=account+security&message=[ProtonCAPTCHA Issue] "
          target="_new"
        >
          {t("ReportProblem.text")}
        </a>
        .
      </p>
    </div>
  );
}
